export default "__VITE_ASSET__Db$zDAKz__"